export default __webpack_public_path__ + "static/media/SyncUsuario.ab43eb6c.svg";